export enum LocaleCode {
  DA = 'da',
  EN_US = 'en-US',
  FR = 'fr',
}
